export default __webpack_public_path__ + "static/media/customers.d603b2d7.svg";